import { track } from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';

const ACCESS_TOKEN = 'access_token';

export const trackViewInErrorPage = (reason: 'PageNotFound' | 'unauthorized', comeFrom: string) => {
    track(ETelemetryNames.ErrorPage, {
        action: ETelemetryActionsAndLabels.View,
        label: ETelemetryActionsAndLabels.View,
        viewData: {
            reason,
            comeFrom,
        },
    });
};

export const trackClickInErrorPage = (buttonName: 'home' | 'support', comeFrom: string) => {
    track(ETelemetryNames.ErrorPage, {
        action: ETelemetryActionsAndLabels.Click,
        label: ETelemetryActionsAndLabels.Click,
        clickData: {
            buttonName,
            comeFrom,
        },
    });
};

export const isAccessTokenPath = (pathname: string) => pathname.includes(ACCESS_TOKEN);

export const splitAccessTokeFromPath = (pathname: string) => {
    if (!isAccessTokenPath(pathname)) return pathname;
    return `/${ACCESS_TOKEN}`;
};
